module.exports = __webpack_public_path__ + "media/images/lb/137-ebc5893d1c38f9b1774e63b82cbf47a2.svg";